import { render, staticRenderFns } from "./orderDetail2.vue?vue&type=template&id=f60ad3aa&scoped=true"
import script from "./orderDetail2.vue?vue&type=script&lang=js"
export * from "./orderDetail2.vue?vue&type=script&lang=js"
import style0 from "./orderDetail2.vue?vue&type=style&index=0&id=f60ad3aa&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f60ad3aa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f60ad3aa')) {
      api.createRecord('f60ad3aa', component.options)
    } else {
      api.reload('f60ad3aa', component.options)
    }
    module.hot.accept("./orderDetail2.vue?vue&type=template&id=f60ad3aa&scoped=true", function () {
      api.rerender('f60ad3aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/orderList/order/lists/orderDetail2.vue"
export default component.exports